<div class="cpcontent googlesignin" [hidden]="isAuthenticatedWithFirebase">
  <h5>Signin with Google to access the Firebase database</h5>
  <br>
  <div class="row">
    <div class="col-md-6">
      <button class="btn btn-primary" (click)="signInWithGoogle()">Sign in with Google</button>
    </div>
  </div>
</div>
<div class="cpcontent" [hidden]="!isAuthenticatedWithFirebase">
  <h1 style="display:inline-block">Performance</h1>
  <i class="bi bi-question-circle" style="font-size: 1.5em;margin-left:20px;color:gray" (click)="showinfo = !showinfo"></i>
  <br>
  <div *ngIf="showinfo" style="margin:20px;padding:20px;background-color:lightgray;border:solid 1px gray">
    Virtex can save performance data to the firebase database.
    The flag is set by the scenario property "doPerformanceLogging".<br><br>

  </div>
  <div class="row">
  <div class="col-md-5">
      <h5>Exercises <span style="font-size:0.85em;color:gray;font-weight:normal">({{exercises.length}})</span></h5>
      <div class="d-flex flex-wrap gap-2 align-items-stretch mb-3">
        <!-- Step 1: Select -->
        <div class="border rounded px-2 py-1 d-flex align-items-center gap-2" style="background:#f0f4ff">
          <small class="text-muted fw-bold">1. Select:</small>
          <button class="btn btn-outline-primary btn-sm" (click)="flagLessThan()">
            <i class="bi bi-check2-square me-1"></i>Check &lt;
          </button>
          <input type="number" [(ngModel)]="flagThreshold" min="0" class="form-control form-control-sm" style="width:60px" />
          <small class="text-muted">NPlayers</small>
        </div>
        <!-- Step 2: Delete -->
        <div class="border rounded px-2 py-1 d-flex align-items-center gap-2" style="background:#fff0f0">
          <small class="text-muted fw-bold">2. Delete:</small>
          <button class="btn btn-danger btn-sm" [disabled]="checkedExercises.size === 0" (click)="deleteChecked()">
            <i class="bi bi-trash me-1"></i>Delete Selected ({{checkedExercises.size}})
          </button>
          <!-- <span class="text-muted">or before</span>
          <input id="cutoffDate" type="date" [(ngModel)]="cutoffDate" class="form-control form-control-sm" style="width:145px" />
          <button class="btn btn-danger btn-sm" (click)="deleteBeforeDate()">
            <i class="bi bi-calendar-x me-1"></i>Delete Older
          </button> -->
        </div>
      </div>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th><input type="checkbox" [checked]="allChecked" (change)="toggleAll()" /></th>
            <th class="sortable" (click)="sortBy('property')">ExerciseId <span>{{tableSortCol==='property' ? (tableSortDir==='asc' ? '▲' : '▼') : '↕'}}</span></th>
            <th>Analyse</th>
            <th class="sortable" (click)="sortBy('scenarioid')">ScenarioId <span>{{tableSortCol==='scenarioid' ? (tableSortDir==='asc' ? '▲' : '▼') : '↕'}}</span></th>
            <th class="sortable" (click)="sortBy('nPlayers')">NPlayers <span>{{tableSortCol==='nPlayers' ? (tableSortDir==='asc' ? '▲' : '▼') : '↕'}}</span></th>
            <th class="sortable" (click)="sortBy('lastRegistered')">Last Registered <span>{{tableSortCol==='lastRegistered' ? (tableSortDir==='asc' ? '▲' : '▼') : '↕'}}</span></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let e of sortedExercises">
            <td><input type="checkbox" [checked]="checkedExercises.has(e.property)" (change)="toggleCheck(e.property)" /></td>
            <td class="link" (click)="selectExercise(e)">{{e.property}}</td>
            <td><button class="btn btn-primary btn-sm" (click)="openAnalysis(e)">Analyse</button></td>
            <td>{{e.scenarioid}}</td>
            <td>{{e.nPlayers}}</td>
            <td>{{e.lastRegistered ? (e.lastRegistered | date:'yyyy-MM-dd HH:mm') : ''}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  <div class="col-md-7">
      <h5>Exercise Details</h5>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Player Name</th>
            <th>registeredAt</th>
            <th>userAgent</th>
            <th>Loading</th>
            <th>Render</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let e of players">
            <td class="link" link (click)="showPlayer(e)">{{e.property}}</td>
            <td>{{e.registeredAt}}</td>
            <td>{{e.userAgent | slice:0:10}}</td>
            <td>{{e.loadDuration}}</td>
            <td>{{e.renderDuration}}</td>
          </tr>
        </tbody>
      </table>
      <button class="btn btn-info btn-sm" (click)="showRawData = !showRawData">Show / Hide Raw Data</button>
      <div *ngIf="showRawData" style="margin-top:10px;white-space:pre-wrap;font-family:monospace;font-size:12px;">
        {{players | json}}
      </div>
    </div>
    <div class="col-md-8">

    </div>
  </div>
</div>
<!-- Modal Component Property ----------------------------------------------->
<div *ngIf="showPlayerModal" #testmodal class="cpmodal">
  <div class="cpmodal-content">
    <div class="cpmodal-header">
      Player Details
    </div>

    <h5>Header</h5>
    <table class="table table-bordered table-sm">
      <thead>
        <tr>
          <th>Exercise</th>
          <th>Player Name</th>
          <th>Registered At</th>

        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{player.exerciseId}}</td>
          <td>{{player.player}}</td>
          <td>{{player.registeredAt}}</td>

        </tr>
      </tbody>
    </table>

    <h5>Operating System</h5>
    <table class="table table-bordered table-sm">
      <thead>
        <tr>
          <th>Platform</th>
          <th>Brand</th>
          <th>userAgent</th>
          <th>Mobile</th>
          <th>Logical Processors</th>

        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{player.platform.platform}}</td>
          <td>{{player.platform.brands}}</td>
          <td>{{player.userAgent}}</td>
          <td>{{player.platform.mobile}}</td>
          <td>{{player.logicalProcessors}}</td>

        </tr>
      </tbody>
    </table>

    <h5>Operating System</h5>
    <table class="table table-bordered table-sm">
      <thead>
        <tr>
          <th>Platform</th>
          <th>Brand</th>
          <th>userAgent</th>
          <th>Mobile</th>
          <th>Logical Processors</th>

        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{player.platform.platform}}</td>
          <td>{{player.platform.brands}}</td>
          <td>{{player.userAgent}}</td>
          <td>{{player.platform.mobile}}</td>
          <td>{{player.logicalProcessors}}</td>

        </tr>
      </tbody>
    </table>

    <br><br>
    {{player | json}}
    <button class="btn btn-primary" style="float:right" (click)="showPlayerModal = false">Cancel</button>
    <div class="spacer10"></div>
  </div>
</div>